import { createFileRoute } from '@tanstack/react-router';
import { TicketsPage } from '@pages/tickets';

/** Tickets-Verwaltung-Route (/tickets) */
export const Route = createFileRoute('/_authenticated/tickets/')({
  component: TicketsPage,
});
